/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const triggerRunQueryParamsSchema = z.object({
    "minIntervalHours": z.optional(z.coerce.number().describe("Skip contacts researched successfully within this many hours. Defaults to MONITORING_MIN_INTERVAL_HOURS; 0 forces a full re-run."))
    }).optional()

/**
 * @description Monitoring run started
 */
export const triggerRun202Schema = z.object({
    "started": z.literal(true)
    })

/**
 * @description minIntervalHours is not a non-negative number
 */
export const triggerRun400Schema = z.any()

export const triggerRunMutationResponseSchema = z.lazy(() => triggerRun202Schema)